import { useAuth } from '../../../core/providers/AuthProvider';
import { useCases } from '../../../core/di/useCases';
import { useCallback } from 'react';

export const useUpdateProfile = () => {
  const { user, setUser, refreshUser } = useAuth();

  const updateProfile = useCallback(async (userData) => {
    if (!user?.uid) {
      throw new Error('Utilisateur non connecté');
    }

    try {
      console.log('DEBUG - Mise à jour du profil:', userData);
      
      // 1. Mettre à jour les données dans Firestore
      await useCases.updateUserProfile.execute(user.uid, userData);
      
      // 2. Recharger explicitement les données utilisateur
      const refreshedUser = await useCases.getUserProfile.execute(user.uid);
      
      // 3. Mettre à jour l'état global de l'utilisateur
      setUser(refreshedUser);
      
      // 4. S'assurer que tout le contexte d'authentification est mis à jour
      if (refreshUser) {
        await refreshUser();
      }
      
      console.log('DEBUG - Profil mis à jour avec succès:', {
        hasLocation: !!refreshedUser.location,
        locationDetails: refreshedUser.location
      });
      
      return refreshedUser;
    } catch (error) {
      console.error('DEBUG - Erreur lors de la mise à jour du profil:', error);
      throw error;
    }
  }, [user?.uid, setUser, refreshUser]);

  return { updateProfile };
}; 